import React from "react";

interface LoadingCardProps {
  className?: string;
}

function LoadingCard({ className = "" }: LoadingCardProps) {
  return (
    <div className={`animate-pulse ${className}`}>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden min-h-[353px]">
        <div className="h-48 bg-gray-200" />

        <div className="p-4 space-y-3">
          <div className="h-6 bg-gray-200 rounded w-24" />

          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-4 bg-gray-200 rounded w-3/4" />
          </div>

          <div className="h-3 bg-gray-200 rounded w-1/2" />

          <div className="space-y-2">
            <div className="h-3 bg-gray-200 rounded w-2/3" />
            <div className="h-3 bg-gray-200 rounded w-1/3" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoadingCard;
